<script lang="ts">
</script>

<div>
  <b>Zoom on canes:</b>
  <br />
  Press 'n' (next) or space to automatically focus on noteworthy canes. Use 'p' (previous)
  to go back to previous cane. Press 'c' (clear) to reset zoom.
  <br />
  Move your mouse wherever you wish.
</div>
